enum PaywallFeaturesEnum {
  InvestorMatching = 'Investor matching',
  CreatePrivateListing = 'Create private listing',
  CreatePrivateEvent = 'Create private event',
  DataExplorer = 'Data explorer',
  OMUpload = 'OM Upload',
}

export default PaywallFeaturesEnum;
